import MoveTo from 'moveto';
import UserAgent from './useragent.js';

const DATA_NAME = "data-drop-";
const DROP_STATUS_NAME = DATA_NAME+"status";
const DROP_HOVER_NAME = DATA_NAME+"hover";
const DROP_NUMBER_NAME = DATA_NAME+"number";

class DropArea {
  constructor($el,number) {
    this.status = 'end';
    this.triggersArr = [];
    this.$el = $el;
    this.hover = (this.$el.attr(DROP_HOVER_NAME) === "true");
    this.$el.attr({[DROP_NUMBER_NAME]:number,[DROP_STATUS_NAME]:this.status});
    if(this.hover){
      this.$el.on({
        "mouseleave": () => {
          this.hide();
        }
      });
    }
  }
  set hover(hover) {
    this._hover = hover;
  }
  get hover(){
    return this._hover;
  }
  changeStatus(){
    let status;
    status = this.$el.attr(DROP_STATUS_NAME);
    if (status === 'end') {
      this.$el.attr({[DROP_STATUS_NAME]:'start'});
    } else {
      this.$el.attr({[DROP_STATUS_NAME]:'move'});
    }
  }
  hide() {
    this.$el.attr({[DROP_STATUS_NAME]:'end'});
    this.triggerHide();
  }
  pushTrigger(trigger){
    this.triggersArr.push(trigger);
  }
  triggerHide() {
    this.triggersArr.forEach(trigger =>{
      trigger.hide();
    });
  }
}

class DropTrigger {
  constructor($el) {
    this.$el = $el;
    this.$control = $('#' + this.$el.attr('aria-controls'));
    this.expand = false;
    this.$el.attr('aria-expanded', false);
    this.$control.attr('aria-expanded', false);
  }
  setArea(area) {
    this.area = area;
    this.setHandle(area.hover);
  }
  setHandle(hover){
    if(hover && UserAgent.isMobile() === null){
      this.setEnterEvent();
    }else{
      this.setClickEvent();
    }
  }
  setClickEvent(){
    this.$el.off('mouseenter.drop');
    this.$el.on({
      'click.drop' : event => {
        event.preventDefault();
        this.do();
      }
    });
  }
  setEnterEvent(){
    this.$el.off('click.drop');
    this.$el.on({
      'mouseenter.drop' : event => {
        this.action();
      }
    });
  }
  action(){
    if(!this.expand){
      this.show();
    }else{
      this.hide();
    }
  }
  show() {
    this.expand = true;
    this.$el.attr('aria-expanded', this.expand);
    this.$control.attr('aria-expanded', this.expand);
    this.$control.on({
      'transitionend webkitTransitionEnd': event => {
        let windowHeight, windowY,targetY;
        windowHeight = window.innerHeight;
        windowY = $(window).scrollTop();
        targetY = this.$el.offset().top;
        if (windowY + (windowHeight - windowHeight / 5) < targetY || windowY - targetY > -10) {
          MoveTo.move(this.$el);
        }
        this.$control.off('transitionend webkitTransitionEnd');
      }
    });
    this.area.changeStatus();
  }
  hide() {
    this.expand = false;
    this.$el.attr('aria-expanded', this.expand);
    this.$control.attr('aria-expanded', this.expand);
  }
}

class DropControl {
  constructor(className) {
    this.className = className;
    this.area = $(className);
    this.trigger = $(className+'-trigger');
    this.areaArr = [];
    this.initArea();
    this.initTrigger();
  }
  initArea(){
    this.area.each((index, element) => {
      let number,area;
      number = index + 1;
      area = new DropArea($(element),number);
      this.areaArr[number] = area;
    });
  }
  initTrigger(){
    this.trigger.each((index, element) => {
      let trigger,areaNumber,area;
      trigger = new DropTrigger($(element));
      areaNumber = $(element).closest(this.className).attr(DROP_NUMBER_NAME);
      area = this.getArea(areaNumber);
      area.pushTrigger(trigger);
      trigger.setArea(area);
    });
  }
  getArea(number){
    return this.areaArr[number];
  }
}

new DropControl('.js-drop');

